import { render, staticRenderFns } from "./AffairsList.vue?vue&type=template&id=3258a550&scoped=true&"
import script from "./AffairsList.vue?vue&type=script&lang=js&"
export * from "./AffairsList.vue?vue&type=script&lang=js&"
import style0 from "./AffairsList.vue?vue&type=style&index=0&id=3258a550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258a550",
  null
  
)

export default component.exports